import React from 'react'

export default function ConfirmTierDownGradeModal() {
    return (
        <div className="py-6">
            This effect will take effect once the next period starts (Beginning of next month).
        </div>
    )
}
